import BaseModel from './BaseModel';
import { asyncFn } from './utils';

class UserModel extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.userListModel = {
      request: this.buildActionName('request', 'user', 'list'),
      response: this.buildActionName('response', 'user', 'list'),
      error: this.buildActionName('error', 'user', 'list'),
    };

    this.userCreateModel = {
      request: this.buildActionName('request', 'user', 'create'),
      response: this.buildActionName('response', 'user', 'create'),
      error: this.buildActionName('error', 'user', 'create'),
    };

    this.userUpdateModel = {
      request: this.buildActionName('request', 'user', 'update'),
      response: this.buildActionName('response', 'user', 'update'),
      error: this.buildActionName('error', 'user', 'update'),
    };

    this.userRemoveModel = {
      request: this.buildActionName('request', 'user', 'delete'),
      response: this.buildActionName('response', 'user', 'delete'),
      error: this.buildActionName('error', 'user', 'delete'),
    };

    this.getUserModel = {
      request: this.buildActionName('request', 'user', 'get'),
      response: this.buildActionName('response', 'user', 'get'),
      error: this.buildActionName('error', 'user', 'get'),
    };

    this.initialState = {
      isLoading: false,
      error: false,
      errorMessage: '',
      data: [],
      current: {},
    };
  }

  list = () => asyncFn({
    url: `${this.url}/list`, method: 'POST', model: this.userListModel,
  })

  create = ({ body }) => asyncFn({
    body, url: `${this.url}/create`, method: 'POST', model: this.userCreateModel,
  })

  update = ({ body }) => asyncFn({
    body, url: `${this.url}/update`, method: 'POST', model: this.userUpdateModel,
  })

  remove = ({ body }) => asyncFn({
    body, url: `${this.url}/remove`, method: 'POST', model: this.userRemoveModel,
  })

  setCurrentUser = id => async (dispatch) => {
    dispatch({
      id,
      type: 'SET_CURRENT_USER',
    });
  }

  reset = () => async (dispatch) => {
    dispatch({
      type: 'FORM_RESET',
    });
  };

  reducer = (state = this.initialState, action) => {
    switch (action.type) {
      case 'FORM_RESET':
        return {
          ...state,
          isLoading: false,
          error: false,
          errorMessage: '',
          current: {},
        };
      case 'SET_CURRENT_USER': {
        let index;
        state.data.list.forEach((user, userIndex) => {
          if (parseInt(user.id, 10) === parseInt(action.id, 10)) {
            index = userIndex;
          }
        });
        return {
          ...state,
          current: state.data.list[index] || {},
        };
      }
      case this.userListModel.request: {
        return {
          ...state,
          isLoading: true,
          error: false,
          errorMessage: '',
        };
      }
      case this.userListModel.error: {
        return {
          ...state,
          isLoading: false,
          error: true,
          errorMessage: action.message,
        };
      }
      case this.userListModel.response: {
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      }
      case this.userCreateModel.request: {
        return {
          ...state,
          isLoading: true,
          error: false,
          errorMessage: '',
        };
      }
      case this.userCreateModel.error: {
        return {
          ...state,
          isLoading: false,
          error: true,
          errorMessage: action.message,
        };
      }
      case this.userUpdateModel.request: {
        return {
          ...state,
          isLoading: true,
          error: false,
          errorMessage: '',
        };
      }
      case this.userUpdateModel.error: {
        return {
          ...state,
          isLoading: false,
          error: true,
          errorMessage: action.message,
        };
      }
      case this.userUpdateModel.response: {
        return {
          ...state,
          isLoading: false,
        };
      }
      case this.userRemoveModel.request: {
        return {
          ...state,
          isLoading: true,
          error: false,
          errorMessage: '',
        };
      }
      case this.userRemoveModel.error: {
        return {
          ...state,
          isLoading: false,
          error: true,
          errorMessage: action.message,
        };
      }
      case this.userRemoveModel.response: {
        return {
          ...state,
          isLoading: false,
        };
      }
      default: {
        return state;
      }
    }
  }
}

export default UserModel;



// WEBPACK FOOTER //
// ./src/models/UserModel.js